import { render, staticRenderFns } from "./terveyskeskuskoulutusjakson-tarkistus.vue?vue&type=template&id=30b0d4be&scoped=true&"
import script from "./terveyskeskuskoulutusjakson-tarkistus.vue?vue&type=script&lang=ts&"
export * from "./terveyskeskuskoulutusjakson-tarkistus.vue?vue&type=script&lang=ts&"
import style0 from "./terveyskeskuskoulutusjakson-tarkistus.vue?vue&type=style&index=0&id=30b0d4be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b0d4be",
  null
  
)

export default component.exports